// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5920":"273557b5","6346":"ae4b1c27","8939":"273557b5"}[chunkId] + ".chunk.css";
};